import { render, staticRenderFns } from "./HomeExperts.vue?vue&type=template&id=71730dde&scoped=true"
import script from "./HomeExperts.js?vue&type=script&lang=js&external"
export * from "./HomeExperts.js?vue&type=script&lang=js&external"
import style0 from "./HomeExperts.scss?vue&type=style&index=0&id=71730dde&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71730dde",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
